<template>
<div class="opera-fangQ">
    <topNav :title="$t('fangQ_title')"></topNav>
    <datepik @change='dateChange' ref="datepik" limit="next" step="9"></datepik>
    <div class="formTop"  :class='{formTopFix:formPosition==true}'>
         <div class="topOne" style="width:15%">{{$t('fangQ_date')}}</div>
         <div class="topOne"  style="width:15%">{{$t('fangQ_available')}}</div>
         <div class="topOne" style="width:15%">{{$t('fangQ_takeup')}}</div>
         <div class="topOne" style="width:15%">{{$t('fangQ_maintenance')}}</div>
         <!-- <div class="topOne" style="width:17%">均价</div> -->
         <div class="topOne" style="width:20%">{{$t('fangQ_rents')}}</div>
         <div class="topOne" style="width:20%">{{$t('fangQ_action')}}</div>
    </div>
	<table class="conditionList"  align='center' style="border-collapse:collapse;">
		<tbody class="tbodyH">
			<tr>
				<th width="15%"></th>
				<th width="15%"></th>
				<th width="15%"></th>
				<th width="15%"></th>
				<!-- <th width="15%"></th> -->
				<th width="20%"></th>
				<th width="20%"></th>
			</tr>
			<tr v-for='(item,key) in condition_list' width="80px" @click='goDetail(item)' :class='{firday:new Date(item.date).getDay()==5,sta:new Date(item.date).getDay()==6}'>
				<td>
					<p>{{item.date.replace(/-/g, '/').substring(5)}}</p>
					<p>{{item.date | week}}</p>
				</td>
				<td>
					{{item.inLive}}
				</td>
				<td>
					{{item.inReservation}}
				</td>
				<td>
					{{item.inRemain}}
				</td>
				<!-- <td>
					{{item.avg}}
				</td> -->
				<td>
					{{item.rate}}
				</td>
				<td>
          {{$t('fangQ_detail')}}
				</td>

			</tr>
		</tbody>
	</table>
</div>

</template>

<script>
import moment from "moment";
import json from "../../conf/datePick.js";
import { Toast } from "mint-ui";
import _ from "lodash";
import datepik from "../operaCommon/datepik";

export default {
  data() {
    return {
      condition_list: [],
      formPosition: false
    };
  },
  mounted() {
    this.getData();
    //监听该页面滚动条
    document
      .getElementsByClassName("opera-fangQ")[0]
      .addEventListener("scroll", this.boxScroll);
  },
  methods: {
    //滚动条上拉下滑顶部固定事件
    boxScroll() {
    //   console.log("监听");
      var pxScoll = document.getElementsByClassName("opera-fangQ")[0].scrollTop;
      this.scrollTop = pxScoll / 37.5;
      var tbodyHeight= document.getElementsByClassName('tbodyH')[0].clientHeight;
      var viewTbodyHeight= document.getElementsByClassName('fangQ')[0].clientHeight;
    //   console.log(this.scrollTop);
    //判断实际表格内容是否比表格直观视图大一些
      if(tbodyHeight>viewTbodyHeight){
            if (this.scrollTop > 1.2) {
                this.formPosition = true;
            } else {
                this.formPosition = false;
            }
      }else{
          this.formPosition = false;
      }

    },
    //生命周期结束后自动执行销毁监听事件
    destroyed() {
      document
        .getElementsByClassName("opera-fangQ")[0]
        .removeEventListener("scroll", this.boxScroll);
    },
    getData(time) {
      this.$http
        .post("/mobilepmsapi/opera/biz/getRoomSituation", { d: time })
        .then(res => {
          if (res.data.result == 0) {
            this.condition_list = res.data.retVal.list;
            this.$refs.datepik.setDateInit(res.data.retVal.d,time == null?res.data.retVal.d:time);
          } else {
            this.msg(res.data.msg);
          }
        });
    },
    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    dateChange(time) {
      this.getData(time);
    },
    goDetail(item) {
      console.log("----item.date---")
      console.log(item.date)
      this.$router.push({ path: "/opera/fangXQ", query: { date: item.date } });
    }
  },
  filters: {
    week(value) {
      return moment(value).day() == 0
        ? json.week[json.week.length - 1]
        : json.week[moment(value).day() - 1];
    }
  },
  components: {
    datepik
  }
};
</script>
<style lang='less'>
.opera-fangQ {
  overflow: auto;
  .formTop {
    width: 100%;
    clear: both;
    .topOne {
      height: 1.06666667rem;
      color: #fff;
      background-color: #f69c2d;
      text-align: center;
      line-height: 1.0133rem;
      float: left;
      font-size: 0.34666667rem;
      font-weight: bold;
      padding: 0;
    }
  }
  .formTopFix {
    position: fixed;
    top: 1.04rem;
    z-index: 200;
  }
  .conditionList {
    width: 100%;
    .firday {
      background: #f6ef8b !important;
    }
    .sta {
      background: #f8e81c !important;
    }
    tr {
      background-color: #fff;
      &:nth-of-type(2n) {
        background-color: #f5f5f5;
      }
      font-size: 0.32rem;
      th {
        color: #fff;
        // height: 1.06666667rem;
        text-align: center;
        font-size: 0.34666667rem;
        background-color: #f69c2c;
        padding: 0;
      }
      td {
        height: 1.56666667rem;
        padding: 0px;
        text-align: center;
        p {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// fangQ.vue?7cc88c6d